import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { ResourceDetailsCoverageTabMetadataCard } from "@/components/pages/common/resource-details/components/content/coverage-content/components/metadata/ResourceDetailsCoverageTabMetadataCard";
import { useAppSelector } from "@/store/hooks";
import { resourceDetailsResourceCoverageDataSelector } from "@/store/resource-details/selectors/coverage-data/resourceDetailsResourceCoverageDataSelector";
import { money } from "@/utils/numeral/money";
import { ResourceDetailsCoverageTabMetadataProgress } from "@/components/pages/common/resource-details/components/content/coverage-content/components/metadata/ResourceDetailsCoverageTabMetadataProgress";

interface ResourceDetailsCoverageTabMetadataCardsProps {
  padding?: number;
}

export const ResourceDetailsCoverageTabMetadataCards: FC<
  ResourceDetailsCoverageTabMetadataCardsProps
> = ({ padding = 1.5 }) => {
  const data = useAppSelector(resourceDetailsResourceCoverageDataSelector);

  return (
    <Stack direction="row" spacing={1} p={padding}>
      <ResourceDetailsCoverageTabMetadataCard title="Coverage">
        <ResourceDetailsCoverageTabMetadataProgress
          total={data?.coverage?.total}
          ri={data?.coverage?.reservation}
          sp={data?.coverage?.savings_plan}
          onDemand={data?.coverage?.on_demand}
        />
      </ResourceDetailsCoverageTabMetadataCard>

      <ResourceDetailsCoverageTabMetadataCard title="Spend Covered by Commitments">
        <Typography fontWeight="medium">
          {money(data?.spend_covered)}
        </Typography>
      </ResourceDetailsCoverageTabMetadataCard>

      <ResourceDetailsCoverageTabMetadataCard title="On-Demand Spend">
        <Typography fontWeight="medium">
          {money(data?.on_demand_spend)}
        </Typography>
      </ResourceDetailsCoverageTabMetadataCard>

      <ResourceDetailsCoverageTabMetadataCard title="Net Savings">
        <Typography fontWeight="medium">{money(data?.net_savings)}</Typography>
      </ResourceDetailsCoverageTabMetadataCard>
    </Stack>
  );
};
